import React from 'react';
import logo from '../assets/sendvigo-logo.png';

function Logo({ size = 'md' }) {
  const sizes = {
    sm: { img: 'h-10', text: 'text-xl', mt: '-mt-3' },
    md: { img: 'h-14', text: 'text-2xl', mt: '-mt-4' },
    lg: { img: 'h-20', text: 'text-4xl', mt: '-mt-6' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className="inline-flex flex-col items-center">
      <img src={logo} alt="SenDViGo" className={s.img} />
      <span className={`font-bold tracking-wide ${s.text} ${s.mt}`}>
        <span className="text-white">Sen</span>
        <span className="text-orange-500">DV</span>
        <span className="text-white">iGo</span>
      </span>
    </div>
  );
}

export default Logo;
